import React from "react";

import codepen from "../img/codepen.png";
import github from "../img/github.png";
import linkedin from "../img/linkedin.png";

class Footer extends React.Component {
	render() {
		return (
			<div id="footer" className="container-fluid text-center py-5">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-8 mx-auto">
							<a
								href="https://drive.google.com/file/d/1iPqFeEDi-506YIfsm_clLVL2GKZnnfGW/view?usp=sharing"
								target="_blank"
								rel="noopener noreferrer">
								<img className="img-fluid" src={codepen} alt=""/>
							</a>
							<a
								className="px-3"
								href="https://github.com/Shubham007-tech"
								target="_blank"
								rel="noopener noreferrer">
								<img src={github} alt=""/>
							</a>
							<a
								href="https://www.linkedin.com/in/shubham-bharti-a086b5225"
								target="_blank"
								rel="noopener noreferrer">
								<img src={linkedin} alt=""/>
							</a>
							
						</div>
					</div>
					<h6 className="pt-2"> shubham.202cricket@gmail.com</h6>
					<h6 className="pt-2"> Pune , Maharashtra</h6>
					<h6 className="pt-2"> 7004995621</h6>
				</div>
			</div>
		);
	}
}

export default Footer;
